import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/AdvertisementManagement';

const getAdsReducer = handleActions({
    [Actions.GetAdvertisementRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetAdvertisementReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetAdvertisementReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetAdvertisement]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const createAdsReducer = handleActions({
    [Actions.CreateAdvertisementRequested]: (state) => ({
        ...state,
        isFetching: true,
        success: false,
    }),
    [Actions.CreateAdvertisementReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.CreateAdvertisementReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearCreateAdvertisement]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const updateAdsReducer = handleActions({
    [Actions.UpdateAdvertisementRequested]: (state) => ({
        ...state,
        isFetching: true,
        success: false,
    }),
    [Actions.UpdateAdvertisementReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.UpdateAdvertisementReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearUpdateAdvertisement]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const deleteAdsReducer = handleActions({
    [Actions.DeleteAdvertisementRequested]: (state) => ({
        ...state,
        isFetching: true,
        success: false,
    }),
    [Actions.DeleteAdvertisementReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.DeleteAdvertisementReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearDeleteAdvertisement]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

export default combineReducers({
    getAds: getAdsReducer,
    createAds: createAdsReducer,
    updateAds: updateAdsReducer,
    deleteAds: deleteAdsReducer,
});
